import $ from 'jquery';
// import Modal from './Modal';

export default class PopupWithProfile {
  constructor() {
    // this.modal = new Modal();
    this.initialize();
  }

  initialize() {
    const popup = new Vue({
      el: '#popup-wrapper',
      data() {
        return {
          profile: null,
          tags: [],
          offset: null,
          visible: null,
          position: null,
        };
      },
      methods: {
        onClick(event) {
          event.stopPropagation();
        },
      },
    });

    let clickedElement = null;
    document.addEventListener('click', (event) => {
      // 対象以外をクリックしたら閉じる
      if (!$(event.target).closest(clickedElement).length) {
        popup.visible = false;
      }
    });

    const triggers = Array.from(document.querySelectorAll('.js-PopupWithProfile'));
    triggers.forEach((el) => {
      new Vue({
        el,
        methods: {
          togglePopup(event) {
            event.preventDefault();
            popup.profile = JSON.parse(event.target.getAttribute('data-profile'));
            popup.tags = JSON.parse(event.target.getAttribute('data-tags'));
            popup.offset = {
              left: `${(event.target.offsetWidth / 2) + parseInt($(event.target).css('margin-left')) - 4}px`,
            };

            // targetの位置を取得
            const bounds = event.target.parentNode.getBoundingClientRect();
            popup.position = {
              position: 'absolute',
              top: `${bounds.top + window.pageYOffset + bounds.height}px`,
              left: `${bounds.left + window.pageXOffset}px`,
            };

            // イベント対象が同じ要素かチェック
            if (event.target === clickedElement) {
              popup.visible = !popup.visible;
            } else {
              popup.visible = true;
            }
            // クリックした要素を保存
            if (popup.visible) {
              clickedElement = event.target;
            }
          },
        },
      });
    });
  }
}
